<script setup>
import {
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogOverlay,
  DialogPortal,
  DialogRoot,
  DialogTitle,
} from 'reka-ui'

import { LazyMotion, m, AnimatePresence } from "motion-v"
const loadFeatures = () => import("~/composables/motionFeatures.js").then(res => res.default)

defineProps({
  center: {
    type: Boolean,
    default: true
  }
})

const model = defineModel();
</script>

<template>
  <DialogRoot v-model:open="model">
    <DialogPortal>
      <LazyMotion :features="loadFeatures" strict>
        <AnimatePresence>

          <DialogOverlay id="dialog-overlay" as-child :class="center ? 'items-center' : 'items-start py-5 sm:pb-10 sm:pt-16'" class="flex justify-center bg-black/50 fixed inset-0 overflow-y-auto z-80">
            <m.div
                :initial="{ opacity: 0 }"
                :animate="{ opacity: 1}"
                :exit="{ opacity: 0 }"
                :transition="{ duration: 0.2, ease: [0.16, 1, 0.3, 1] }"
            >
              <DialogContent
                  as-child
                  :class="[
              $attrs.class,
              center ? '' : '',
              'relative bg-white p-5 rounded-lg z-60'
            ]"
              >
                <m.div
                    :initial="{ opacity: 0, scale: 0.9 }"
                    :animate="{ opacity: 1, scale: 1 }"
                    :exit="{ opacity: 0, scale: 0.9 }"
                    :transition="{ duration: 0.2, ease: [0.16, 1, 0.3, 1] }"
                >
                  <dialog-description/>

                  <slot></slot>

                  <DialogClose class="absolute top-4 left-4 text-muted inline-flex appearance-none items-center justify-center rounded-full cursor-pointer" aria-label="Close">
                    <Icon name="linear:close" class="size-7"/>
                  </DialogClose>
                </m.div>
              </DialogContent>
            </m.div>
          </DialogOverlay>
        </AnimatePresence>
      </LazyMotion>
    </DialogPortal>
  </DialogRoot>
</template>

<style scoped>
@media screen and (max-height: 460px) {
  #dialog-overlay{
    align-items: flex-start !important;
    padding: 20px 0 ;
  }
}
</style>